module.exports = __webpack_public_path__ + "331b287ba503ae7387ff3c33ef234852.pdf";